"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_client_1 = require("@cian/http-client");
var utils_1 = require("../../shared/http/utils");
var websocket_1 = require("../websocket");
exports.DEFAULT_WS_API_PATH = 'v1/endpoint-desktop/';
var EventChannel = /** @class */ (function () {
    function EventChannel(params) {
        this.baseWSUri = {
            port: 80,
            scheme: 'ws',
        };
        this.typedHandler = function (fn) {
            return function (event) {
                try {
                    var eventData = JSON.parse(event.data);
                    fn(__assign({}, event, { data: eventData }));
                }
                catch (err) {
                    console.error(err);
                    fn(event);
                }
            };
        };
        var WSApiPath = params.apiMethodPath || exports.DEFAULT_WS_API_PATH;
        this.baseWSUri = __assign({}, this.baseWSUri, params.baseWSUri, { path: http_client_1.mergePaths(utils_1.getApiPath(params.apiPath, params.baseWSUri.path), WSApiPath) });
    }
    EventChannel.prototype.connectToEventChannel = function () {
        if (this.eventChannel && !this.eventChannel.isSocketClosed()) {
            return undefined;
        }
        if (!this.eventChannel) {
            this.eventChannel = new websocket_1.WebSocketClient({ uri: __assign({}, this.baseWSUri) });
        }
        return this.eventChannel.open();
    };
    EventChannel.prototype.addIncommingMessageListener = function (fn) {
        if (!this.eventChannel || this.eventChannel.isSocketClosed()) {
            return null;
        }
        var handler = this.typedHandler(fn);
        return this.eventChannel.addEventListener('message', handler);
    };
    EventChannel.prototype.removeIncommingMessageListener = function (identifier) {
        this.eventChannel.removeEventListener('message', identifier);
    };
    EventChannel.prototype.addEventChannelListener = function (type, fn) {
        return this.eventChannel.addEventListener(type, fn);
    };
    EventChannel.prototype.removeEventChannelListener = function (type, fn) {
        this.eventChannel.removeEventListener(type, fn);
    };
    EventChannel.prototype.closeEventChannel = function (code, reason) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.eventChannel && !this.eventChannel.isSocketClosed()) {
                    return [2 /*return*/, this.eventChannel.close(code, reason)];
                }
                return [2 /*return*/, true];
            });
        });
    };
    EventChannel.prototype.sendMessage = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.eventChannel) {
                    throw new Error('Socket connection not open');
                }
                return [2 /*return*/, this.eventChannel.send(message)];
            });
        });
    };
    EventChannel.prototype.updateSession = function (session) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.eventChannel) {
                    throw new Error('Socket connection not open');
                }
                return [2 /*return*/, this.eventChannel.send(session)];
            });
        });
    };
    EventChannel.prototype.isChannelClosed = function () {
        if (!this.eventChannel) {
            return true;
        }
        return this.eventChannel.isSocketClosed();
    };
    EventChannel.prototype.hasInstance = function () {
        return !!this.eventChannel;
    };
    return EventChannel;
}());
exports.EventChannel = EventChannel;
//# sourceMappingURL=index.js.map